const ue = [
    { course: "UE1/Minor/2nd Major mapping", done : false},
    { course: "UE2/Minor/2nd Major mapping", done : false},
    { course: "UE3/Minor/2nd Major mapping", done : false},
    { course: "UE4/Minor/2nd Major mapping", done : false},
    { course: "UE5/Minor/2nd Major mapping", done : false},
    { course: "UE6/Minor/2nd Major mapping", done : false},
    { course: "UE7/Minor/2nd Major mapping", done : false},
    { course: "UE8/Minor/2nd Major mapping", done : false},     
];

export default ue;